import React from "react";

export default function RegistrationSucces() {
    return (
        <>
            <h4 className="mb-1">Registrácia takmer hotová</h4>
            <span className="mt-2 fs-6">Na Váš email bol odoslaný verfikačný email, po kliknutí na odkaz bude Váš účet aktivovaný.</span>
        </>
    );
}